import React from "react";
import { createPortal } from "react-dom";

import Tooltip from "components/Tooltip";

import { getCoolingZoneWarningText, getCoolingZoneErrorText } from "utils/singleZoneCooling/warnings-errors";

import WarningIcon from "assets/images/icons/warning.svg";
import ErrorIcon from "assets/images/icons/warning-red.svg";
import ResultsIcon from "assets/images/icons/Ready.svg";
import NoResultsIcon from "assets/images/icons/warning-yellow.svg";
import RerunIcon from "assets/images/icons/Icon-Reset-blue.svg";

import classes from "./styles.module.scss";

// Displays Tooltips for the Zone Accordion whether open or closed
const ZoneAccordionTooltips = ({ zoneId = "" }) =>
    createPortal(
        <div id={`zone-accordion-tooltips-${zoneId}`}>
            <Tooltip id={`zone-${zoneId}-label-tip`} />
            <Tooltip id={`zone-${zoneId}-floor-area-tip`} />
            <Tooltip id={`zone-${zoneId}-perimeter-volume-tip`} />
        </div>,
        document.body
    );

const getZoneStatusIcon = (type) => {
    return {
        "Results": ResultsIcon,
        "Ready": ResultsIcon,
        "Warning": WarningIcon,
        "Error": ErrorIcon,
        "Changes": RerunIcon,
        "NoResults": NoResultsIcon,
    }[type] || "";
};

// Displays Status Icon and Tooltip
const ZoneStatusTooltip = ({ id, className, status = "", messages = [] }) => {
    const tooltipText = messages.reduce((acc, message) => acc + `<p>${message}</p>`, "");
    const src = getZoneStatusIcon(status);

    return (
        <div
            className={`${classes.tooltipIcon} ${className && className}`}
            data-html
            data-tip={`<span style="display:block;max-width:20rem;">${tooltipText}</span>`}
            data-for={`${id}_status`}
        >
            <img src={src} alt={status} />
            {
                createPortal(
                    <Tooltip id={`${id}_status`} />,
                    document.body
                )
            }
        </div>
    )
};

// Displays Warning Icon and Tooltip
const ZoneWarningTooltip = ({ id, className, warning }) => {
    const warningText = getCoolingZoneWarningText(warning);

    return (
        <div
            className={`${classes.tooltipIcon} ${className && className}`}
            data-html
            data-tip={`<span style="display:block;max-width:14rem;">${warningText}</span>`}
            data-for={`${id}_warning`}
        >
            <img src={WarningIcon} alt="warning" />
            {
                createPortal(
                    <Tooltip id={`${id}_warning`} />,
                    document.body
                )
            }
        </div>
    )
};

// Displays Error Icon and Tooltip
const ZoneErrorTooltip = ({ id, className, error, formattedValue = 0 }) => {
    const errorText = getCoolingZoneErrorText(error, formattedValue);

    return (
        <div
            className={`${classes.tooltipIcon} ${className && className}`}
            data-html
            data-tip={`<span style="display:block;max-width:14rem;">${errorText}</span>`}
            data-for={`${id}_error`}
        >
            <img src={ErrorIcon} alt="error" />
            {
                createPortal(
                    <Tooltip id={`${id}_error`} />,
                    document.body
                )
            }
        </div>
    )
}

export { ZoneAccordionTooltips, ZoneStatusTooltip, ZoneWarningTooltip, ZoneErrorTooltip };
